import React from 'react';
import './BioMedicalWasteAuthorization.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import bmw_dummy_1 from '../../assets/images/bio-medical-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_bmw_banner from '../../assets/images/img_peso1_banner.png';
import { FaRecycle, FaFileAlt, FaShieldAlt, FaHeartbeat, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function BioMedicalWasteAuthorization() {
  const bmwBenefits = [
    {
      icon: <FaHeartbeat />,
      title: 'Public Health Protection',
      text: 'Safeguard communities from risks associated with bio-medical waste.',
    },
    {
      icon: <FaRecycle />,
      title: 'Environmental Safety',
      text: 'Ensure safe handling and disposal of bio-medical waste.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Regulatory Compliance',
      text: 'Adhere to the Bio-Medical Waste Management Rules, 2016.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Minimized Legal Risks',
      text: 'Avoid penalties with proper waste management authorization.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Consultation',
      description: 'Discuss your facility’s bio-medical waste management needs.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Document Preparation',
      description: 'Prepare all required documents for authorization.',
    },
    {
      icon: <FaRecycle />,
      title: 'Waste Management Plan',
      description: 'Develop a compliant waste management plan for your facility.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the application to the appropriate pollution control board.',
    },
    {
      icon: <FaCertificate />,
      title: 'Authorization Issuance',
      description: 'Receive authorization to handle bio-medical waste responsibly.',
    },
  ];

  const acts = [
    "Bio-Medical Waste Management Rules, 2016",
    "Environment Protection Act, 1986",
    "Water (Prevention and Control of Pollution) Act, 1974",
    "Air (Prevention and Control of Pollution) Act, 1981"
  ];

  const explanation = "These regulations ensure safe and responsible management of bio-medical waste, reducing risks to public health and the environment.";

  const checklistItems = [
    { name: 'Facility Registration', description: 'Provide proof of healthcare facility registration.' },
    { name: 'Waste Disposal Agreement', description: 'Agreement with an authorized bio-medical waste disposal agency.' },
    { name: 'Waste Management Plan', description: 'A detailed plan for handling and disposing of bio-medical waste.' },
    { name: 'Compliance Reports', description: 'Submission of previous compliance reports, if applicable.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Bio-Medical Waste Authorization Services"
        subheading="Ensure your facility adheres to all regulations for safe bio-medical waste management."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/bio-medical-waste-authorization" }}
        backgroundImage={bmw_dummy_1}
      />

      <ServicesOverviewSection
        title="What is Bio-Medical Waste Authorization?"
        description="Bio-medical waste authorization ensures healthcare facilities safely manage and dispose of bio-medical waste, complying with government regulations."
        image={img_bmw_banner}
        altText="Bio-Medical Waste Authorization"
      />

      <ServicesBenefitsSection
        title="Why You Need Bio-Medical Waste Authorization"
        description="Learn the importance of obtaining authorization for bio-medical waste management."
        benefits={bmwBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Key Regulations Governing Bio-Medical Waste"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Bio-Medical Waste Authorization Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Bio-Medical Waste Authorization Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
